import React, { useEffect } from "react";
import TicketNoBuy from "../component/TicketNoBuy";
import PreviousBarInvoice from "../component/PreviousBarInvoice"
import { useNavigate, useLocation } from "react-router-dom";
import { getTickets } from '../features/lotteryInvoice'
import { useSelector, useDispatch } from 'react-redux';
import numToFixed, { numToFixed2 } from "../helper/numToFixed";
import { changeTypeToName } from "../helper/changeBankIdtoName";

const CardHead = (props) => (
    <div
        className={`${props.isCancel == "yes"
            ? "bg-defaultStatusCancel text-defaultStatusCancel2"
            : props.isWin == "yes"
                ? "bg-defaultStatusWin text-defaultStatusWin2"
                : props.isWin == "no"
                    ? "bg-defaultStatusLost text-defaultStatusLost2"
                    : "bg-defaultStatusWatting text-defaultStatusWatting2"
            } rounded-t`}
    >
        <div className="px-1 py-1">
            <div className="text-center font-bold flex justify-between text-xs text-defaultPoyName">
                <p>{props.lotteryName}</p>
                <p>โพย #{props.refCode}</p>
            </div>
            <div className="text-center text-xs flex justify-between text-defaultTextMenuMobile2">
                <p>รอบ: {props.yeekeeRound ? props.yeekeeRound : new Date(props.closeSaleDatetime).toLocaleDateString("th-TH")}</p>
                <p>เวลาซื้อ: {new Date(props.date).toLocaleString("th-TH")}</p>
            </div>
        </div>
        <div className="text-left px-1 text-xs">
            <p>บันทึกโพย: {props.remark}</p>
        </div>
        <div className="text-center px-1 flex justify-between bg-white text-xs border-b">
            <div className="text-left">
                <p className="text-defaultTextMenuMobile2">ยอดแทง: <span className="text-defaultStatusWin2 font-bold">{numToFixed(props.totalBetAmount)}<span style={{ fontFamily: 'Menlo' }}>฿</span></span></p>
            </div>
            <div className="text-left">
                <p>รายการทั้งหมด: {props.length}</p>
            </div>
        </div>
    </div>
);

const Card = (props) => {
    // console.log(props)
    var statusInvoice = ''
    if (props.data.isCancel == "yes") {
        statusInvoice = 'text-defaultStatusCancel2 bg-defaultStatusCancel'
    } else if (props.data.isWin == "yes") {
        statusInvoice = 'text-defaultStatusWin2 bg-defaultStatusWin'
    } else if (props.data.isWin == "no") {
        statusInvoice = 'text-defaultStatusLost2 bg-defaultStatusLost'
    } else {
        statusInvoice = 'text-defaultStatusWatting2 bg-defaultStatusWatting'
    }
    return (
        <>
            <div className="w-auto text-sm mx-1">
                <div className="grid gap-0.5 grid-cols-10 text-xs">
                    <div className="col-span-1 text-left text-xs font-bold text-defaultTextMenuMobile2">
                        {'#' + props.i}
                    </div>
                    <div className="col-span-3 text-xs">
                        <p className={`font-bold`}>{changeTypeToName(props.data.lotteryType)}</p>
                    </div>
                    <div className={"col-span-2 text-left text-xs w-full rounded " + statusInvoice}>
                        <p className="font-bold">
                            {props.data.lotteryNumber}
                        </p>
                    </div>
                    <div className={"col-span-4 w-full flex justify-between rounded bg-white text-defaultTextMenuMobile2"}>
                        <div>
                            <p className={`text-xs`}>ราคา</p>
                            <p className={`text-xs font-bold`}>
                                {numToFixed2(props.data.betAmount)}
                                {/* <span style={{ fontFamily: 'Menlo' }}>฿</span> */}
                            </p>
                        </div>
                        <div>
                            <p className={`text-xs`}>บาทละ</p>
                            <p className={`text-xs font-bold`}>
                                {numToFixed2(props.data.rewardRate)}
                                {/* <span style={{ fontFamily: 'Menlo' }}>฿</span> */}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

const resultNumber = (result, ticketType, isWin) => {
    let results = "";
    if (result.length && isWin != 'wait') {
        result.map((data) => {
            if (data.betType == ticketType) {
                results = data.betNumber.toString();
            }
        });
        return results;
    } else {
        return 'รอผล'
    }

};
const PreviewPrint = React.forwardRef((props, ref) => {
    const location = useLocation();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const tickets = useSelector((state) => state.invoice.ticket);

    var lotteryName = '';
    var yeekeeRound = '';
    var stringLength = '';

    if (location?.state?.lotteryName) {
        if (location?.state?.lotteryName.substring(0, 11) == 'จับยี่กี 5G SUPER') {
            lotteryName = 'จับยี่กี 5G SUPER'
            stringLength = location?.state?.lotteryName.length
            yeekeeRound = location?.state?.lotteryName.substring(19, stringLength)
        } else if (location?.state?.lotteryName.substring(0, 8) == 'จับยี่กี SUPER') {
            lotteryName = 'จับยี่กี SUPER'
            stringLength = location?.state?.lotteryName.length
            yeekeeRound = location?.state?.lotteryName.substring(16, stringLength)
        } else {
            lotteryName = location?.state?.lotteryName
        }
    }

    useEffect(() => {
        // console.log("location", location)
        if (location?.state?._id) {
            const body = { id: location?.state?._id };
            dispatch(getTickets(body));
        } else {
            navigate('/historyhuay')
        }
    }, [])
    return (
        <div className="md:mx-10 w-auto rounded-lg pb-10 text-center text-black px-1 md:px-10 font-bold">
            <PreviousBarInvoice data={location?.state} lotteryRound={tickets} />
            <div className="grid grid-cols-1 gap-0 w-[270px] mx-auto text-center">
                <div
                    ref={ref}
                    className={`${location?.state.isCancel == "yes"
                        ? "border-defaultStatusCancel2"
                        : location?.state.isWin == "yes"
                            ? "border-defaultStatusWin2"
                            : location?.state.isWin == "no"
                                ? "border-defaultStatusLost2"
                                : "border-defaultStatusWatting2"
                        }  h-auto mx-1 mt-1 border text-sm bg-white border-dashed`}
                >
                    <CardHead
                        name={location?.state.lotteryName}
                        date={location?.state.invoiceDatetime}
                        result={tickets?.results}
                        totalBetAmount={tickets?.totalBetAmount}
                        winLoseAmount={tickets?.totalPayAmount}
                        refCode={location?.state.refCode}
                        lotteryName={lotteryName}
                        yeekeeRound={yeekeeRound}
                        closeSaleDatetime={location?.state.closeSaleDatetime}
                        isWin={location?.state.isWin}
                        isCancel={location?.state.isCancel}
                        remark={location?.state.remark}
                        length={tickets?.ticketList.length}
                    />
                    <div className="border-gray-800">
                        {/* {console.log(tickets.ticketList)} */}
                        {tickets.ticketList?.map((data, i) => (
                            // console.log(data)
                            <Card
                                key={i}
                                i={i + 1}
                                result={tickets?.results}
                                lotteryType={data.lotteryType}
                                isWin={data.isWin}
                                data={data}
                                length={tickets?.ticketList.length}
                            />
                        ))}
                    </div>
                    {location.state.lotteryId === "63c4f776743b79857e6a654e" ?
                        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 pt-5 p-5">
                            {tickets.ticketList?.map((data, i) => (
                                // console.log(data)
                                <TicketNoBuy data={data} />
                            ))}

                        </div> :
                        <></>
                    }
                </div>
            </div>

        </div>
    )
}
)

export default PreviewPrint